module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGNIC/f9TwlmGDVg1IBRA4aLAQCpfwkfJC8iKQAAAABJRU5ErkJggg=="